/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 2 = CollectionAndelivery
 *
 * 4 = WhileYouWait
 *
 * 5 = StandartBooking
 *
 * 99 = LoanCar
 *
 * 100 = Recovery
 */
export enum TransportOptionEnum {
  CollectionAndelivery = 2,
  WhileYouWait = 4,
  StandartBooking = 5,
  LoanCar = 99,
  Recovery = 100,
}
